import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import PhotoInput from "@/components/PhotoInput";
import { api, apiError } from "@/lib/api";

const EMPTY = { title: "", detail: "", due_date: "", photo_path: null };

export default function CounterpartForm({ open, onOpenChange, sponsorId, item, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(item ? { title: item.title, detail: item.detail, due_date: item.due_date, photo_path: item.photo_path } : EMPTY); }, [open, item]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const run = async (fn, msg) => {
    setBusy(true);
    try { await fn(); toast.success(msg); onOpenChange(false); onSaved(); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  const submit = (e) => {
    e.preventDefault();
    run(() => (item ? api.put(`/counterparts/${item.id}`, f) : api.post(`/sponsors/${sponsorId}/counterparts`, f)),
      item ? "Contrepartie modifiée" : "Contrepartie ajoutée");
  };
  const remove = () => window.confirm("Supprimer cette contrepartie ?") && run(() => api.delete(`/counterparts/${item.id}`), "Contrepartie supprimée");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[520px] max-h-[92vh] overflow-y-auto rounded-[14px]" data-testid="counterpart-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{item ? "Modifier la contrepartie" : "Ajouter une contrepartie"}</DialogTitle>
          <DialogDescription>Ce que le club s'engage à fournir au sponsor.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block"><span className="field-label">Titre</span><input className="field" required value={f.title} onChange={set("title")} data-testid="counterpart-title-input" /></label>
          <label className="block"><span className="field-label">Détail</span><textarea className="field h-auto py-2 min-h-[80px]" value={f.detail} onChange={set("detail")} data-testid="counterpart-detail-input" /></label>
          <label className="block"><span className="field-label">Date prévue</span><input className="field" type="date" required value={f.due_date} onChange={set("due_date")} data-testid="counterpart-due-input" /></label>
          <PhotoInput value={f.photo_path} onChange={(p) => setF({ ...f, photo_path: p })} testId="counterpart-photo" />
          <div className="flex flex-col-reverse sm:flex-row sm:justify-between gap-2 pt-2">
            {item ? <button type="button" className="btn-ghost text-[#8A4B00]" onClick={remove} data-testid="counterpart-delete-button">Supprimer</button> : <span />}
            <div className="flex flex-col-reverse sm:flex-row gap-2">
              <button type="button" className="btn-outline" onClick={() => onOpenChange(false)} data-testid="counterpart-form-cancel">Annuler</button>
              <button className="btn-primary" disabled={busy} data-testid="counterpart-form-submit">Enregistrer</button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
